import { useDropzone } from 'react-dropzone';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Dialog, Popover, Tooltip, withStyles } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/WarningTwoTone';
import Constant from '@/common/constant/Constant';
import { downloadFileFromS3, getLinkDownloadFileFromS3 } from './FileUploaded';
import Utils from '@/common/utils/utils';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import { cloneDeep } from 'lodash';
import TooltipThumb from './TooltipThumb';
import { handleOpenTicketDetail, isDisplayHyperLinkFileKnowledge } from '@/component/ticketKnowledge/handler/DetailTicketHandler';
import { displayTagOfThumbAttach } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import { PropTypes } from 'prop-types';
import { useSnackbar } from 'notistack';
import ReplaceFileDialog from './ReplaceFileDialog';
import TranslationConstant from '@/common/constant/TranslationConstant';
import FileTranslationDialog from './fileTranslation/FileTranslationDialog';
import { isTranslatableFileName } from '@/common/utils/translationJobUtils';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';
import CorporationUtils from '@/common/utils/CorporationUtils';
import { useRecoilValue } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';

const ButtonOption = withStyles({
    root: {
        '&:hover': {
            backgroundColor: '#ecf2fb'
        },
        padding: '10px 20px 10px 20px',
        justifyContent: 'flex-start'
    }
})(Button);

const FlagMessageCopyLink = withStyles({
    tooltip: {
        color: '#1DA578',
        backgroundColor: '#D7F4E2',
        padding: '8px 16px',
        fontSize: '14px',
        boxShadow: '6px 5px 5px -4px rgba(0,0,0,0.3)'
    },
    arrow: {
        color: '#D7F4E2'
    }
})(Tooltip);

export const EditFileUploaded = ({
    fileUploadList,
    setFileUploadList,
    fileUpdatedList,
    setValue,
    register,
    listFieldEdited,
    fileDeletedList,
    isEmail,
    acceptedFileExtensions,
    allowMultipleFiles = true,
    limitFileSize,
    note,
    ...props
}) => {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    register(props?.name);
    const [publicForCustomer, setPublicForCustomer] = useState(0);
    const [isDisable, setIsDisable] = useState(false);
    const divRef = useRef(null);
    const isUploadForEmailTicket = props.selectTicketType === Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL || props.ticketType === Constant.TICKET_TYPE.EMAIL;
    const [openPreviewImage, setOpenPreviewImage] = useState(null);
    const [openOption, setOpenOption] = useState(null);
    const [openFileOption, setOpenFileOption] = useState(null);
    const [isShowFlagMessage, setIsShowFlagMessage] = useState(false);
    const [isReplaceDialogOpen, setIsReplaceDialogOpen] = useState(false);
    const [replaceTargetFile, setReplaceTargetFile] = useState(null);
    const [isTranslateDialogOpen, setIsTranslateDialogOpen] = useState(false);
    const [translateTargetFile, setTranslateTargetFile] = useState(null);
    const { enqueueSnackbar } = useSnackbar();
    // B2B / B2C customers are gated on the project owning this ticket / knowledge.
    const corporationDetail = useRecoilValue(corporationAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    

    /**
     * Get pending replace file data for a given fileUrl.
     * Returns the replace item from fileUploadList if exists, otherwise null.
     */
    const getPendingReplaceFile = useCallback((fileUrl) => {
        if (!fileUrl || !fileUploadList?.length) return null;
        return fileUploadList.find(
            item => item.isReplace && item.replaceTarget?.fileUrl === fileUrl
        ) || null;
    }, [fileUploadList]);

    useEffect(() => {
        if (props.setShowButtonEditTicket) {
            props.setShowButtonEditTicket();
        }
        
    }, [fileUploadList?.length]);

    useEffect(() => {
        setPublicForCustomer(props.data.structure.publicForCustomer);

        setIsDisable(
            props?.data?.structure?.publicForCustomer === 2 ||
                props?.hasEditFieldPermissions === false ||
                !Utils.isEmptyString(props?.detailTicket?.deletedAt) ||
                props?.detailTicket?.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED ||
                props?.isDisableEdit === true
        );
    }, [
        props.data.structure.publicForCustomer,
        props?.detailTicket,
        props?.hasEditFieldPermissions,
        props?.isDisableEdit
    ]);

    const [defaultValue, setDefaultValue] = useState([]);

    const onDrop = useCallback(
        acceptedFiles => {
            handleDragFileOnChange(acceptedFiles);
            return;
        },
        [fileUploadList, listFieldEdited]
    );

    const handleDefaultValueAndCurrentPanelInitData = () => {
        let fileUpdatedListClone = props.currentPanelInitData.fileUpdatedList;
        let listUrlOfFileUpdated = fileUpdatedListClone.map(file => {
            return file.fileUrl
        });

        let listFileOfFieldValue =Utils.isEmptyArray(props?.defaultValue) ? [] : props?.defaultValue
        let listUrlFileOfFieldValue =  listFileOfFieldValue.map(file => {
            return file.fileUrl
        });

        let listFileOfDefaultValue = [];

        fileUpdatedListClone?.forEach((file) => {
            if(listUrlFileOfFieldValue.includes(file.fileUrl)){
                listFileOfDefaultValue.push(file)
            }
        })

        listFileOfFieldValue?.forEach((file) => {
            if(!listUrlOfFileUpdated.includes(file.fileUrl)){
                listFileOfDefaultValue.push(file)
            }
        })

        return listFileOfDefaultValue
    }

    useEffect(() =>{
        if(props.currentPanelInitData && !Utils.isEmptyObject(props.currentPanelInitData)) {
            if (props.currentPanelInitData.fileUploadList) {
                setFileUploadList(props.currentPanelInitData.fileUploadList);
                props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(); 
            }
        }

    }, [])

    const filterDefaultValue = value => {
        let newValue = [];
        let newFileUploadedList = !Utils.isEmptyArray(fileDeletedList)
            ? value.filter(
                  item =>
                      !Utils.isImageFile(item.fileName) &&
                      !fileDeletedList.find(i => i.fileUrl === item.fileUrl)
              )
            : value.filter(item => !Utils.isImageFile(item.fileName));
        // get list image
        let fileImageList = !Utils.isEmptyArray(fileDeletedList)
            ? value.filter(
                  item =>
                      Utils.isImageFile(item.fileName) &&
                      !fileDeletedList.find(i => i.fileUrl === item.fileUrl)
              )
            : value.filter(item => Utils.isImageFile(item.fileName));
        newValue = [...newFileUploadedList, ...fileImageList];
        return newValue;
    };

    useEffect(() => {
        if (props.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY) return;
        if (!props?.defaultValue || Utils.isEmptyArray(props?.defaultValue) || typeof props?.defaultValue === 'string') {
            setDefaultValue([]);
            props.setFileUpdatedList([]);
            return;
        };

        if(props.currentPanelInitData && !Utils.isEmptyObject(props.currentPanelInitData) && !Utils.isEmptyArray(props.currentPanelInitData.fileUpdatedList)) {
            let defaultValueData = handleDefaultValueAndCurrentPanelInitData();

            // Update HyperlinkIcon FileKnowledge when existed
            defaultValueData = defaultValueData.map(valueData => {
                let updateValueData = {...valueData}
                if (valueData.isPdf) {
                    for (let i = 0; i < props?.defaultValue?.length; i++) {
                        const newValueData = props?.defaultValue[i];
                        if (newValueData.fileUrl === updateValueData.fileUrl && newValueData.idTicketFileKnowledge) {
                            updateValueData = {...newValueData}
                        }
                    }
                }
                return updateValueData
            })

            setDefaultValue(filterDefaultValue(defaultValueData));
            props.setFileUpdatedList(defaultValueData);
        } else {
            setDefaultValue(filterDefaultValue([...props?.defaultValue]));
            props.setFileUpdatedList([...props?.defaultValue]);
            if (!isEmail) {
               updatePanelInitData(props.panelId, props.tabId, props.panelInitData, props.setPanelInitData, 'fileUpdatedList', [...props?.defaultValue]); 
            }
        }
        
        if (!Utils.isEmptyArray(...props?.defaultValue)) {
            setValue(props?.name, 'fileUploaded');
            props.clearErrors(props?.name);
        } else {
            setValue(props?.name, '');
        }
    }, [props?.defaultValue]);

    useEffect(() => {
        if (props.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY) return;
        if ((!Utils.isEmptyArray(fileUploadList) || !Utils.isEmptyArray(props?.defaultValue)) && isUploadForEmailTicket && props.setErrorCreateTicket) {
            let totalFileSize = 0;
            fileUploadList.forEach(file => {
                if (file?.file?.size) {
                    totalFileSize += parseInt(file?.file?.size);
                }
            })
            let defaultValueFile = props?.defaultValue;
            if (!Utils.isEmptyArray(defaultValueFile)) {
                defaultValueFile.forEach(file => {
                    if (file?.fileSize) {
                        totalFileSize += parseInt(file?.fileSize);
                    }
                })
            }

            if (totalFileSize) {
                let convertTotalFileSizeToMB = Utils.convertByteToMB(totalFileSize)
                if (convertTotalFileSizeToMB > Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) {
                    props.setErrorCreateTicket(
                        props?.name,
                        { type: 'manual', message: trI18n('MGS-FILE-OVER-CAPACITY').replace('{{fileSize}}', Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) },
                        { shouldFocus: true }
                    );
                }
            } else {
                props.clearErrors(props?.name); 
            }
        } else {
            props.clearErrors(props?.name);
        }
    }, [fileUploadList, props?.defaultValue]);

    // uef to ONLY EMAIL_REPLY (because: too many re-render if use common's uef)
    useEffect(() => {
        if (props.ticketType !== Constant.TICKET_TYPE.EMAIL_REPLY) return;

        setDefaultValue(filterDefaultValue([...props?.defaultValue]));
        if (!isEmail) {
            props.setFileUpdatedList([...props?.defaultValue]);
            updatePanelInitData(props.panelId, props.tabId, props.panelInitData, props.setPanelInitData, 'fileUpdatedList', [...props?.defaultValue]);
        }
    }, [props?.isTriggerReloadCurrentTicket, fileDeletedList, props?.defaultValue])

    const getErrorMessage = useCallback((errorCode) => {
        switch (errorCode) {
            case Constant.UPLOAD_FILE_ERROR_CODE.FILE_TOO_LARGE:
                return buildSnackbarMessage('ERROR_MESSAGE_OVER_FILE_SIZE', { '{fileSize}': `${limitFileSize}MB` });
            case Constant.UPLOAD_FILE_ERROR_CODE.FILE_INVALID_TYPE:
                return buildSnackbarMessage('ERROR_MESSAGE_INVALID_FORMAT_FILE');
            case Constant.UPLOAD_FILE_ERROR_CODE.TOO_MANY_FILES:
                return buildSnackbarMessage('ERROR_MESSAGE_OVER_AMOUNT_FILE', { '{amountFile}': '1' });
            default:
                return 'Unknown file error';
        }
    }, [limitFileSize]);

    const showErrorSnackbar = useCallback((message) => {
        enqueueSnackbar(message, { 
            variant: 'error',
            autoHideDuration: 2000 
        });
    }, [enqueueSnackbar]);

    const handleRejectedFiles = useCallback((rejectedFiles) => {
        if (!rejectedFiles || rejectedFiles.length === 0) return;

        rejectedFiles.forEach((rejected) => {
            if (rejected.errors && rejected.errors.length) {
                rejected.errors.forEach(error => {
                    const errorMessage = getErrorMessage(error.code) || error.message;
                    showErrorSnackbar(errorMessage);
                });
            }
        });
    }, [getErrorMessage, showErrorSnackbar]);

    const handleDrop = useCallback((acceptedFiles, rejectedFiles) => {
        
        if (!allowMultipleFiles &&!Utils.isEmptyArray(acceptedFiles) && !Utils.isEmptyArray(rejectedFiles)) {
            handleRejectedFiles(rejectedFiles);
            return;
        }
        
        // Handle accepted files
        onDrop(acceptedFiles);
        
        // Handle rejected files
        handleRejectedFiles(rejectedFiles);
    }, [allowMultipleFiles, onDrop, handleRejectedFiles]);

    const { getRootProps, getInputProps } = useDropzone({ 
        onDrop: handleDrop,
        disabled: isDisable,
        accept: acceptedFileExtensions && acceptedFileExtensions.length > 0 ? acceptedFileExtensions.join(',') : undefined,
        multiple: !!allowMultipleFiles,
        maxSize: limitFileSize ? limitFileSize * 1024 * 1024 : undefined,
    });

    const handleDragFileOnChange = fileList => {
        const tempFileUploadList = [];
        const structureForm = Utils.convertJSONDataToObject(props.parentForm?.structure);

        // Process all files first
        for (const file of fileList) {
            if (file) {
                const type = file.type;
                const fileUpload = {
                    file: file,
                    progress: 0,
                    status: true,
                    key: '',
                    splitPdf: Boolean(structureForm?.splitPdf),
                    // CR-2026-006: BR-12 — default to format's autoTranslateAttachment setting.
                    // autoTranslateAttachment is a top-level form field, not inside structure JSON.
                    autoTranslate: Boolean(props?.autoTranslateAttachment),
                    isExpand: true,
                    isPdf: type === 'application/pdf'
                };
                tempFileUploadList.push(fileUpload);
            }
        }

        // Only proceed if there are files to upload
        if (!allowMultipleFiles && Utils.isEmptyArray(tempFileUploadList)) {
            return;
        }
        // Determine new file upload list based on multiple files setting
        const newFileUploadList = allowMultipleFiles 
            ? [...fileUploadList, ...tempFileUploadList]
            : [...tempFileUploadList];

        if (!allowMultipleFiles && !Utils.isEmptyArray(tempFileUploadList)) {
            // handle delete existingFiles & uploadedFiles
            const existingFiles = [...defaultValue];
            if (!Utils.isEmptyArray(existingFiles) && props?.setFileDeletedList) {
                existingFiles.forEach(file => {
                    props.setFileDeletedList(prev => [...prev, { ...file, isDelete: true }]);
                });
            }            
            if (!Utils.isEmptyArray(existingFiles)) {
                const deletedFiles = existingFiles.map(file => ({ ...file, isDelete: true }));
                if (props?.setFileUpdatedList) {
                    props?.setFileUpdatedList(prev => [...prev, ...deletedFiles])
                }
                if (props?.setFileDeletedList) {
                    props?.setFileDeletedList(prev => [...prev, ...deletedFiles])
                }
            }
            
            if (props?.setFileUpdatedList) {
                props?.setFileUpdatedList(prev => [...prev].map(p => ({...p, isDelete: true})));
            }
            setDefaultValue([]);
        }

        // Update form edit state
        if (props?.setIsEdited) {
            if (props?.setOnChangeEdit) {
                props.setOnChangeEdit(!props.onChangeEdit);
            }
            props.setIsEdited(true);
            
            const newFieldEdited = listFieldEdited?.filter(id => 
                id !== 'attachment' && id !== 'suffixOfAttachments'
            ) || [];
            
            props.setListFieldEdited([...newFieldEdited, 'attachment', 'suffixOfAttachments']);
        }
        
        // Update file upload list and form values
        setFileUploadList(newFileUploadList);
        setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, newFileUploadList);

        // Update field value based on whether files were uploaded
        if (!Utils.isEmptyArray(tempFileUploadList)) {
            setValue(props?.name, 'fileUploaded');
            props.clearErrors(props?.name);
        } else {
            setValue(props?.name, '');
        }

        // Trigger button edit ticket callback
        props?.setShowButtonEditTicket?.();
    };

    const handleDeleteFile = index => {
        setOpenOption(null);
        setOpenFileOption(null);
        let newFileUploadList = cloneDeep(fileUploadList);
        if (newFileUploadList[index]) {
            newFileUploadList.splice(index, 1);
        }

        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            let newFieldEdited = listFieldEdited?.filter(id => {
                return id !== 'attachment' && id !== 'suffixOfAttachments';
            });
            newFieldEdited = Utils.isEmptyArray(newFieldEdited) ? [] : newFieldEdited;
            props?.setListFieldEdited([...newFieldEdited, 'attachment', 'suffixOfAttachments']);
        }

        setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, newFileUploadList);
        setFileUploadList([...newFileUploadList]);
        props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
        if(!Utils.isEmptyArray(newFileUploadList)) {
            setValue(props?.name, 'fileUploaded');
            props.clearErrors(props?.name);
        } else {
            setValue(props?.name, '');
        }
    };

    const isDisplayConvertPDFEditFunction = (isPdf = false) => {
        const isServicesPDFOfCorpOn = props.detailTicket?.convertPDFOrg === 1 ? true : false;
        const commonCondition = Utils.isEmptyString(props.detailTicket?.deletedAt) && props?.isDisplaySplitPdfSwitch && isPdf && isServicesPDFOfCorpOn;
    
        if(props.detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT) {
            return props.hasEditFieldPermissions === true && commonCondition;
        }
        return commonCondition;
    }

    const onChangePdf = (index) => {
        props.setIsEdited(true);
        setFileUploadList(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].splitPdf = !prev[index].splitPdf;
            setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, prevClone);
            return prevClone;
        })
    }

    const onChangePdfFileUploaded = (index) => {
        props.setIsEdited(true);
        setDefaultValue(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].splitPdf = !prev[index].splitPdf;
            if(!prev[index]?.isPdf) prevClone[index].isPdf = Utils.isNameOrUrlOfPdfFile(prev[index]?.fileName)
            return prevClone;
        })
        
        props.setFileUpdatedList(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].splitPdf = !prev[index].splitPdf;
            if(!prev[index]?.isPdf) prevClone[index].isPdf = Utils.isNameOrUrlOfPdfFile(prev[index]?.fileName)
            return prevClone;
        })
    }

    // CR-2026-006: toggle the per-file auto-translate flag (stored alongside splitPdf on each attachment).
    const onChangeAutoTranslate = (index) => {
        props.setIsEdited(true);
        setFileUploadList(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].autoTranslate = !prev[index].autoTranslate;
            setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, prevClone);
            return prevClone;
        })
    }

    const onChangeAutoTranslateFileUploaded = (index) => {
        props.setIsEdited(true);
        setDefaultValue(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].autoTranslate = !prev[index].autoTranslate;
            return prevClone;
        })
        props.setFileUpdatedList(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].autoTranslate = !prev[index].autoTranslate;
            return prevClone;
        })
    }

    // CR-2026-006: STUB — will query TranslationJob (queryTranslationJobByS3Url + hashS3Url)
    // to determine whether the file was already auto-translated. When true, the toggle must be
    // disabled on edit (BR-13). Returns false for now; the real query is a separate task.
    // For existing files (not new uploads): if autoTranslate is already ON, disable the toggle
    // (BR-13 — file is already being auto-translated, do not allow changing it back).
    const isFileAlreadyAutoTranslated = (file) => {
        // New uploads can always be toggled (BR-12 / BR-14)
        if (file?.isNewUpload) return false;
        // Disable only when the SAVED server value is ON (defaultAutoTranslate).
        // Do NOT check the live openFileOption.autoTranslate — that reflects the current
        // edit state and would lock the toggle as soon as the user flips it ON.
        return Boolean(file?.defaultAutoTranslate);
    };

    const renderImageFileUploadItem = (fileUploadInfor, item, url, index) => {
        return (
            <div
                className="class-relative cursor-default listmap-item"
                style={{ display: 'flex', gap: 5 }}
            >
                <TooltipThumb
                    value={`${item.content}(${formatBytes(item.fileSize)})`}
                    className="titleDisplay"
                >
                    <img
                        alt=""
                        src={url}
                        style={{
                            height: 50,
                            width: 70,
                            objectFit: 'cover'
                        }}
                        onClick={() => setOpenPreviewImage(url)}
                    />
                </TooltipThumb>
                <div
                    style={{
                        height: 50,
                        backgroundColor: '#ecedef',
                        width: 20,
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                    onClick={e => {
                        setOpenFileOption({ ...item, index, isNewImg: true });
                        setOpenOption(e.currentTarget);
                    }}
                >
                    <img src="/assets/image/icon-more-panel.svg" alt="" />
                </div>
            </div>
        );
    };

    const renderOtherFileUploadItem = (fileUploadInfor, item, index, displayTextInFile, isPdf, splitPdf, autoTranslate) => {
        return (
            <div
                className="class-relative cursor-default listmap-item"
                style={{ display: 'flex', gap: 5 }}
            >
                <TooltipThumb
                    value={`${item.content}(${formatBytes(item.fileSize)})`}
                    className="titleDisplay"
                >
                    <img
                        style={{
                            height: 50,
                            width: 70,
                            objectFit: 'cover',
                            cursor: 'pointer'
                        }}
                        src="/assets/image/others_file.png"
                        alt=""
                    />
                </TooltipThumb>
                <div
                    style={{
                        height: 50,
                        backgroundColor: '#ecedef',
                        width: 20,
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                    onClick={e => {
                        setOpenFileOption({
                            ...item,
                            index,
                            isNewImg: true,
                            isNewUpload: true,
                            splitPdf: Boolean(splitPdf),
                            canEditPdfSearchTarget:
                                Boolean(isPdf && props?.isDisplaySplitPdfSwitch),
                            // CR-2026-006: per-file auto-translate flag + edit availability
                            autoTranslate: Boolean(autoTranslate),
                            canEditAutoTranslate: isDisplayAutoTranslateTarget(item?.fileName || item?.file?.name || item.content)
                        });
                        setOpenOption(e.currentTarget);
                    }}
                >
                    <img src="/assets/image/icon-more-panel.svg" alt="" />
                </div>
                <span
                    className="file-attachment-thumbnail-label"
                    style={{ backgroundColor: displayTextInFile.colorCode }}
                >
                    {displayTextInFile.name}
                </span>
                {fileUploadInfor?.status === false && (
                    <div
                        style={{
                            position: 'absolute',
                            right: 25,
                            bottom: 0
                        }}
                    >
                        <WarningIcon color="error" fontSize="small" />
                    </div>
                )}
            </div>
        );
    };

    const renderFiledUpload = () => {
        let contentChatList = [];
        if (Utils.isEmptyString(props.detailTicket?.deletedAt)) {
            fileUploadList
                .filter(item => !item.isReplace)
                .forEach((fileUploadInfor, index) => {
                const isPdf = fileUploadInfor.isPdf;
                const splitPdf = fileUploadInfor.splitPdf;
                const autoTranslate = fileUploadInfor.autoTranslate;
                let item = { content: fileUploadInfor.file.name, fileSize: fileUploadInfor.file.size };
                let url = '';
                if (fileUploadInfor.file instanceof File || fileUploadInfor.file instanceof Blob) {
                    url = URL.createObjectURL(fileUploadInfor.file);
                } else if (typeof fileUploadInfor.file === 'string') {
                    url = fileUploadInfor.file;
                } else if (typeof fileUploadInfor.file === 'object' && fileUploadInfor.isDuplicate) {
                    url = getLinkDownloadFileFromS3(
                        {
                            ...fileUploadInfor.file,
                            type: Constant.S3_FILE_TYPE.TICKET_FILE,
                        },
                        props.detailTicket,
                        null,
                        Constant.ATTACH_FILE.VIEW_TICKET_DETAIL
                    );
                }
                const displayTextInFile = getDisplayTextInFile(fileUploadInfor.file.name);

                contentChatList.push(
                    <li key={fileUploadInfor.key || fileUploadInfor.file.name || index} style={{ marginBottom: 0 }}>
                        {Utils.isImageFile(fileUploadInfor.file.name)
                            ? renderImageFileUploadItem(fileUploadInfor, item, url, index)
                            : renderOtherFileUploadItem(fileUploadInfor, item, index, displayTextInFile, isPdf, splitPdf, autoTranslate)
                        }
                    </li>
                );
            });
        }
        if (Utils.isEmptyArray(contentChatList)) return contentChatList;

        return (
            <div
                key="file-upload-list"
                style={{
                    display: 'flex',
                    columnGap: 10,
                    rowGap: 10,
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                    marginBottom: defaultValue.length ? 10 : 0
                }}
            >
                {contentChatList}
            </div>
        );
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (!+bytes) return '0 B'
    
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    
        const i = Math.floor(Math.log(bytes) / Math.log(k))
    
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }

    const getDisplayTextInFile = fileName => {
        return displayTagOfThumbAttach(props.detailTicket || {}, fileName) || { colorCode: '', name: '' };
    };

    const buildOpenFileOption = (file, index, imageLength = 0) => {
        const attachFile = props.detailTicket?.attachFiles?.find(
            i => i.fileInfo?.fileUrl === file?.fileUrl
        );
        const isPdf = file?.isPdf ? file.isPdf : Utils.isNameOrUrlOfPdfFile(file?.fileName);
        const defaultFileData = !Utils.isEmptyArray(props.defaultValue)
            ? props.defaultValue.find(fileDefault => fileDefault.fileUrl === file?.fileUrl)
            : {};

        return {
            ...attachFile,
            index,
            imageLength,
            sourceFile: file,
            isPdf,
            splitPdf: Boolean(file?.splitPdf),
            defaultSplitPdf: Boolean(defaultFileData?.splitPdf),
            canEditPdfSearchTarget: isDisplayConvertPDFEditFunction(isPdf),
            canOpenFileKnowledge: isDisplayHyperLinkFileKnowledge(
                file,
                props.detailTicket?.convertPDFOrg
            ),
            // CR-2026-006: per-file auto-translate flag + edit availability.
            // Legacy files have autoTranslate=null → fall back to form's setting (Bug 1 fix).
            autoTranslate: file?.autoTranslate != null ? Boolean(file?.autoTranslate) : Boolean(props?.autoTranslateAttachment),
            // defaultAutoTranslate tracks the value saved on the server.
            // Used by isFileAlreadyAutoTranslated to lock the toggle only when
            // the server value is already ON — not the live edit state (Bug 3 fix).
            defaultAutoTranslate: Boolean(file?.autoTranslate),
            canEditAutoTranslate: isDisplayAutoTranslateTarget(file?.fileName),
            canTranslateFile: isDisplayTranslateFileOption(file)
        };
    };

 
    /**
     * The 翻訳 option is a VIEW-mode action, so it must not be gated on `isDisable` - that flag is
     * true exactly when the field is read-only, which is when translation is allowed.
     * Archived / soft-deleted tickets stay translatable on purpose.
     *
     * The toggles below are the same ones AI Chat checks (InputChatAI), and the backend re-checks
     * them, so hiding the option here is convenience, not the security boundary.
     */
    const isDisplayTranslateFileOption = file => {
        if (props?.displayMode !== Constant.DISPLAY_MODE.VIEW) return false;
        if (!isTranslatableFileName(file?.fileName)) return false;
        // Only files already stored on the server can be translated
        if (file?.isNewImg || file?.isNewUpload) return false;
        if (getPendingReplaceFile(file?.fileUrl)) return false;

        return CorporationUtils.isEnableSettingFileTranslationAttachment(corporationDetail, projectInuseDetail);
    };

    const handleOpenTranslateDialog = () => {
        setTranslateTargetFile(openFileOption);
        setIsTranslateDialogOpen(true);
        setOpenOption(null);
    };

    const handleOpenFileKnowledge = () => {
        const file = openFileOption?.sourceFile;
        if (!file?.idTicketFileKnowledge) return;

        setOpenOption(null);
        handleOpenTicketDetail(
            file.idTicketFileKnowledge,
            Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE,
            '',
            '',
            props?.setIsLoading,
            props?.currentUserDetail,
            props?.projectInuseDetail,
            props?.setIsOpenAccessDeniedPopup,
            props?.addNewPanel,
            props?.panelId,
            props?.isCustomer
        );
    };

    const handleTogglePdfSearchTarget = () => {
        if (
            !openFileOption?.canEditPdfSearchTarget ||
            isDisable ||
            openFileOption?.defaultSplitPdf
        ) {
            return;
        }

        if (openFileOption?.isNewUpload) {
            onChangePdf(openFileOption.index);
        } else {
            onChangePdfFileUploaded(openFileOption.index);
        }
        setOpenFileOption(prev => ({
            ...prev,
            splitPdf: !prev?.splitPdf,
            sourceFile: {
                ...prev?.sourceFile,
                splitPdf: !prev?.splitPdf
            }
        }));
    };

    // CR-2026-006: whether a file is a translatable type (pdf/docx/pptx/xlsx).
    const isTranslatableFile = (fileName) => {
        if (Utils.isEmptyString(fileName)) return false;
        const ext = fileName.split('.').pop().toLowerCase();
        return TranslationConstant.TRANSLATION_SUPPORTED_EXTENSIONS.includes(ext);
    };

    // CR-2026-006: whether the per-file auto-translate toggle should be shown.
    // In edit mode: requires the org multilingual+file-translation gate ON (isDisplayAutoTranslateSwitch)
    //               so only editors from enabled orgs can toggle it.
    // In view mode: only requires form's autoTranslateAttachment setting — B2C/B2B/partner users
    //               can see the toggle status regardless of their own org's settings (Bug 6 fix).
    const isDisplayAutoTranslateTarget = (fileName) => {
        if (!Boolean(props?.autoTranslateAttachment)) return false;
        if (!isTranslatableFile(fileName)) return false;
        // Edit mode: also gate on org/project level setting and field edit permission
        return Boolean(props?.isDisplayAutoTranslateSwitch)
    };

    // CR-2026-006: toggle the per-file auto-translate flag. When the file was already
    // auto-translated (stub), the toggle is disabled (BR-13) so it cannot be changed.
    const handleToggleAutoTranslateTarget = () => {
        if (
            !openFileOption?.canEditAutoTranslate ||
            isDisable ||
            isFileAlreadyAutoTranslated(openFileOption)
        ) {
            return;
        }

        if (openFileOption?.isNewUpload) {
            onChangeAutoTranslate(openFileOption.index);
        } else {
            onChangeAutoTranslateFileUploaded(openFileOption.index);
        }
        setOpenFileOption(prev => ({
            ...prev,
            autoTranslate: !prev?.autoTranslate,
            sourceFile: {
                ...prev?.sourceFile,
                autoTranslate: !prev?.autoTranslate
            }
        }));
    };


    const deleteFile = index => {
        setOpenOption(null);
        setOpenFileOption(null);
        let defaultValueTmp = cloneDeep(defaultValue);
        if (defaultValueTmp[index]) {
            defaultValueTmp.splice(index, 1);
        }
        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
            let newFieldEdited = listFieldEdited?.filter(id => {
                return id !== 'attachment' && id !== 'suffixOfAttachments';
            });
            newFieldEdited = Utils.isEmptyArray(newFieldEdited) ? [] : newFieldEdited;
            props?.setListFieldEdited([...newFieldEdited, 'attachment', 'suffixOfAttachments']);
        }
        const fileDeletedList = defaultValue[index];

        // Remove pending replace file if user deletes the original file
        const deletedFileUrl = fileDeletedList?.fileUrl || '';
        if (!Utils.isEmptyString(deletedFileUrl)) {
            const filteredUploadList = fileUploadList.filter(item => {
                if (item.isReplace && item.replaceTarget?.fileUrl === deletedFileUrl) {
                    if (item.replaceBlobUrl) URL.revokeObjectURL(item.replaceBlobUrl);
                    return false;
                }
                return true;
            });
            if (filteredUploadList.length !== fileUploadList.length) {
                setFileUploadList(filteredUploadList);
                setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, filteredUploadList);
            }
        }

        if (props?.setFileDeletedList) {
            props?.setFileDeletedList(prev => [...prev, {...fileDeletedList, isDelete: true}])
        }
        setDefaultValue([...defaultValueTmp]);
        if(!Utils.isEmptyArray(fileUpdatedList)){
            let fileUpdatedListClone = fileUpdatedList?.filter((file => file.isDelete));
            fileUpdatedListClone.push({ ...fileDeletedList, isDelete: true });
            props.setFileUpdatedList([...defaultValueTmp, ...fileUpdatedListClone]);
        }else{
            props.setFileUpdatedList([...defaultValueTmp, { ...fileDeletedList, isDelete: true }]);
        }
    };

    const isDisplayBoxUploadFile = () => {
        // Don't show drag & drop area in view mode
        if (props?.hasEditFieldPermissions === false) {
            return false;
        }

        if (!Utils.isEmpty(props.addTicket)) {
            return true;
        }

        if (props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE) {
            return props?.hasEditFieldPermissions;
        }

        return publicForCustomer === Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE;
    }

    const renderFileImageUpload = (fileImageList, imageLength) => {
        return (
            <div
                key="file-image-list"
                style={{
                    display: 'flex',
                    columnGap: 10,
                    rowGap: 10,
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                    marginBottom: isDisplayBoxUploadFile() && fileImageList.length ? 10 : 0
                }}
            >
                {fileImageList
                    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                    .map((item, index) => {
                        const pendingReplace = getPendingReplaceFile(item.fileUrl);
                        const displayFileSize = pendingReplace ? pendingReplace.file.size : item.fileSize;
                        const thumbnailInfo =
                            item?.thumbnailInfo ||
                            props?.detailTicket?.attachFiles?.find(
                                att => att?.fileInfo?.fileUrl === item.fileUrl
                            )?.thumbnailInfo;
                        const imgThumbnailLink = pendingReplace?.replaceBlobUrl
                            ? pendingReplace.replaceBlobUrl
                            : getLinkDownloadFileFromS3(
                                {
                                    ...item,
                                    type: Constant.S3_FILE_TYPE.TICKET_FILE,
                                    thumbnailInfo: JSON.stringify(thumbnailInfo)
                                },
                                props.detailTicket,
                                null,
                                Constant.ATTACH_FILE.VIEW_TICKET_DETAIL
                            );

                        const imgLink = pendingReplace?.replaceBlobUrl
                            ? pendingReplace.replaceBlobUrl
                            : getLinkDownloadFileFromS3(
                                {
                                    ...item,
                                    type: Constant.S3_FILE_TYPE.TICKET_FILE,
                                    thumbnailInfo: null
                                },
                                props.detailTicket
                            );
                            let kboardUploadedAt = '';
                            if (!Utils.isEmptyString(item?.kboardUploadedAt)) {
                                kboardUploadedAt = item?.kboardUploadedAt
                            }
                        return (
                            <li
                                key={item.id}
                                className="justify-content-center"
                                style={{ marginBottom: 0 }}
                            >
                                <div className="display-thumb">
                                    <div
                                        className="class-relative cursor-default"
                                        style={{ display: 'flex', gap: 5 }}
                                    >
                                        <TooltipThumb
                                            value={`${item.fileName}(${formatBytes(
                                                displayFileSize
                                            )}) ${kboardUploadedAt}`}
                                            className="titleDisplay"
                                        >
                                            <img
                                                style={{
                                                    height: 50,
                                                    width: 70,
                                                    objectFit: 'cover',
                                                    cursor: 'pointer'
                                                }}
                                                src={
                                                    Utils.isImageFile(item.fileName)
                                                        ? imgThumbnailLink
                                                        : '/assets/image/others_file.png'
                                                }
                                                alt=""
                                                aria-label="more"
                                                aria-controls="long-menu"
                                                aria-haspopup="true"
                                                onClick={() => {
                                                    setOpenPreviewImage(imgLink);
                                                }}
                                            />
                                        </TooltipThumb>
                                        <div
                                            style={{
                                                height: '100%',
                                                backgroundColor: '#ecedef',
                                                width: 20,
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}
                                            onClick={e => {
                                                setOpenFileOption(buildOpenFileOption(item, index, imageLength));
                                                setOpenOption(e.currentTarget);
                                            }}
                                        >
                                            <img src="/assets/image/icon-more-panel.svg" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </li>
                        );
                    })}
            </div>
        );
    };

    const renderFileUploaded = fileUploadedList => {
        let newFileUploadedList = fileUploadedList
            .filter(item => !Utils.isImageFile(item.fileName) && !item.isDelete)
            .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

        // get list image
        let fileImageList = fileUploadedList.filter(item => Utils.isImageFile(item.fileName));
        fileImageList = fileImageList.filter((file) => !file.isDelete )
        fileImageList = Utils.sortByCreatedAtAsc(fileImageList);
        let fileNotImageLength = newFileUploadedList.length;
        let fileUploadedComponentList = [];

        newFileUploadedList?.forEach((file,index) => {
            const displayTextInFile = getDisplayTextInFile(file.fileName);
            const pendingReplace = getPendingReplaceFile(file.fileUrl);
            const displayFileSize = pendingReplace ? pendingReplace.file.size : file.fileSize;
            const fileUploadedComponent = (
                <li key={file.id || file.fileUrl || index} style={{ marginBottom: 0 }}>
                    <div className="display-thumb">
                        <div
                            className="class-relative cursor-default listmap-item"
                            style={{ display: 'flex', gap: 5 }}
                        >
                            <TooltipThumb
                                value={`${file.fileName}(${formatBytes(displayFileSize)})`}
                                className="titleDisplay"
                            >
                                <img
                                    style={{
                                        height: 50,
                                        width: 70,
                                        objectFit: 'cover',
                                        cursor: 'pointer'
                                    }}
                                    src="/assets/image/others_file.png"
                                    alt=""
                                    onClick={() => {
                                        if (pendingReplace?.replaceBlobUrl) {
                                            window.open(pendingReplace.replaceBlobUrl, '_blank');
                                        } else {
                                            downloadFileFromS3(
                                                { type: 1, ...file },
                                                props.detailTicket,
                                                false,
                                                false,
                                                '',
                                                props?.setIsShowPopupLogout
                                            );
                                        }
                                    }}
                                />
                            </TooltipThumb>
                            <div
                                style={{
                                    height: '100%',
                                    backgroundColor: '#ecedef',
                                    width: 20,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                                onClick={e => {
                                    setOpenFileOption(buildOpenFileOption(file, index, 0));
                                    setOpenOption(e.currentTarget);
                                }}
                            >
                                <img src="/assets/image/icon-more-panel.svg" alt="" />
                            </div>
                            <span
                                className="file-attachment-thumbnail-label"
                                style={{ backgroundColor: displayTextInFile.colorCode }}
                            >
                                {displayTextInFile.name}
                            </span>
                        </div>
                    </div>
                </li>
            );

            fileUploadedComponentList.push(fileUploadedComponent);
        });
        let fileImageComponentList = renderFileImageUpload(fileImageList, fileNotImageLength)

        return [
            <div
                key="file-not-image-list"
                style={{
                    display: 'flex',
                    columnGap: 10,
                    rowGap: 10,
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                    marginBottom:
                        fileUploadedComponentList.length &&
                        (fileImageList.length || isDisplayBoxUploadFile())
                            ? 10
                            : 0
                }}
            >
                {fileUploadedComponentList}
            </div>,
            fileImageComponentList
        ];
    };
    
    const isCustomerHasFileUpload = (fileUploadedList) => {
        if (!Utils.isEmpty(props.addTicket)) {
            return false;
        }

        return props.componentName !== Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE && 
        publicForCustomer !== Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE && 
        fileUploadedList.length <= 0
    }

    const isCustomerKnowledgeHasFileUpload = (fileUploadedList) => {
        if (!Utils.isEmpty(props.addTicket)) {
            return false;
        }

        return props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE && 
        !props?.hasEditFieldPermissions && 
        fileUploadedList.length <= 0
    }

    const renderLabel = fileUploadedList => {
        // Don't show title in view mode when there's no data
        if (props?.hasEditFieldPermissions === false && fileUploadedList.length <= 0) {
            return '';
        }

        if (
            isCustomerHasFileUpload(fileUploadedList) ||
            isCustomerKnowledgeHasFileUpload(fileUploadedList)
        ) {
            return '';
        }

        return (
            <>
                <div className="cell-prod-status gap-8">
                    {props?.isTooltipTitle ? (
                        <div className="d-flex">
                            <Tooltip title={props?.label}>
                                <span className="form-addTicket-label text-truncate">
                                    <label
                                        className={
                                            'text-truncate line-height-18' +
                                            (publicForCustomer
                                                ? 'form-addTicket-label-color'
                                                : 'form-addTicket-label')
                                        }
                                    >
                                        {props?.label}
                                    </label>
                                </span>
                            </Tooltip>
                            {props.data.structure.required && (
                                <span className="required padding-left-4">*</span>
                            )}
                        </div>
                    ) : (
                        <label
                            className={
                                publicForCustomer
                                    ? 'form-addTicket-label-color'
                                    : 'form-addTicket-label'
                            }
                        >
                            {props?.label}
                            {props.data.structure.required && (
                                <span className="required">*</span>
                            )}
                        </label>
                    )}
                    {props?.isShowIconCopyFieldId && (
                        <Tooltip title={props?.data.id} placement="top" arrow>
                            <img
                                src="/assets/image/icon-copy.svg"
                                alt="copy"
                                onClick={() => navigator.clipboard.writeText(props?.data.id)}
                            />
                        </Tooltip>
                    )}
                </div>
                {note && <span className='font-size-13' style={{ display: 'block' }}>{note}</span>}
            </>
        );
    };


    const preventOpenNewTab = (e) => {
        if (isDisable) {
            e.nativeEvent.preventDefault();
            if (!e) return;
        }
    }

    const preventDraggingOpenNewTab = {
        onDrop: e => preventOpenNewTab(e)
    }

    const isEmptyUploadFile = () => {
        if (!props.data.structure.required) return false;
        if (!Utils.isEmptyArray(fileUploadList)) return false;
        let isEmptyAfterEdit = false;
        if (!Utils.isEmptyArray(fileUpdatedList)) {
            let listNotDelete = fileUpdatedList.filter(file => !file.isDelete);
            if (Utils.isEmptyArray(listNotDelete)) {
                isEmptyAfterEdit = true;
            }
        }
        
        return !props.isDuplicate && isEmptyAfterEdit;
    }

    const onClickCopyShareLink = useCallback(() => {
        const linkUrl = Utils.getShareLinkImg({
            attachFile: openFileOption,
            dataShareLink: props.detailTicket.dataShareLink
        });

        navigator.clipboard.writeText(linkUrl);
        setIsShowFlagMessage(true);
        setTimeout(() => {
            setIsShowFlagMessage(false);
        }, 3000);
    }, [props.detailTicket, openFileOption]);

    const handleOpenReplaceDialog = () => {
        setReplaceTargetFile(openFileOption);
        setIsReplaceDialogOpen(true);
        setOpenOption(null);
    };

    const handleReplaceFile = (newFile, uploadedTmpS3Path) => {
        if (!replaceTargetFile) return;

        const originalFileName = replaceTargetFile?.sourceFile?.fileName
            || replaceTargetFile?.fileInfo?.fileName
            || '';
        const originalFileUrl = replaceTargetFile?.sourceFile?.fileUrl
            || replaceTargetFile?.fileInfo?.fileUrl
            || '';
        const structureForm = Utils.convertJSONDataToObject(
            props.parentForm?.structure
        );
        const isPdf = newFile.type === 'application/pdf';

        const replaceFileUpload = {
            file: newFile,
            progress: 100,
            status: true,
            key: uploadedTmpS3Path,
            splitPdf: Boolean(structureForm?.splitPdf),
            isExpand: true,
            isPdf,
            isReplace: true,
            tmpS3Path: uploadedTmpS3Path,
            replaceBlobUrl: URL.createObjectURL(newFile),
            replaceTarget: {
                fileUrl: originalFileUrl,
                fileName: originalFileName,
                s3Path: replaceTargetFile?.sourceFile?.s3Path
                    || replaceTargetFile?.fileInfo?.s3Path
                    || replaceTargetFile?.fileInfo?.fileUrl
                    || '',
                fileSize: replaceTargetFile?.sourceFile?.fileSize
                    || replaceTargetFile?.fileInfo?.fileSize
                    || 0
            }
        };

        // Fix #3: Remove previous replace for the same target file
        let updatedUploadList = fileUploadList.filter(item => {
            if (item.isReplace && item.replaceTarget?.fileUrl === originalFileUrl) {
                // Revoke old blob URL
                if (item.replaceBlobUrl) URL.revokeObjectURL(item.replaceBlobUrl);
                return false;
            }
            return true;
        });
        updatedUploadList = [...updatedUploadList, replaceFileUpload];
        setFileUploadList(updatedUploadList);
        setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, updatedUploadList);
        setValue(props?.name, 'fileUploaded');
        props.clearErrors(props?.name);

        if (props?.setIsEdited) {
            props.setIsEdited(true);
            if (props?.setOnChangeEdit) {
                props.setOnChangeEdit(!props.onChangeEdit);
            }
            let newFieldEdited = listFieldEdited?.filter(id => {
                return id !== 'attachment' && id !== 'suffixOfAttachments';
            }) || [];
            props.setListFieldEdited([
                ...newFieldEdited, 'attachment', 'suffixOfAttachments'
            ]);
        }

        props?.setShowButtonEditTicket?.();
        setReplaceTargetFile(null);
    };

    const isCanReplaceFile = () => {
        if (isDisable) return false;
        if (!openFileOption) return false;
        // Only show for saved files (not newly uploaded)
        if (openFileOption?.isNewImg || openFileOption?.isNewUpload) return false;
        // Must not be from a chat post origin
        if (openFileOption?.originId?.includes('post')) return false;
        // Hide replace option for draft ticket/knowledge
        if (props.detailTicket?.public === Constant.TICKET_PUBLIC.DRAFT) return false;
        // Hide when ticket is soft delete
        if (props.detailTicket?.deletedAt) return false;
        // Hide when ticket is archived
        if (props.detailTicket?.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED) return false;
        return true;
    };

    const isReplaceFileDisabled = () => {
        // Only check isCreatingPageKnowledge for knowledge/master knowledge tickets
        if (
            props.detailTicket?.ticketType !== Constant.TICKET_TYPE.KNOWLEDGE &&
            props.detailTicket?.ticketType !== Constant.TICKET_TYPE.MASTER_KNOWLEDGE
        ) {
            return false;
        }
        
        // Disable replace when PDF is currently splitting pages
        if (
            openFileOption?.sourceFile?.isCreatingPageKnowledge && 
            openFileOption?.sourceFile?.isPdf && 
            openFileOption?.sourceFile?.splitPdf
        ) {
            return true;
        }

        return false;
    };

    return (
        <div className="form-addTicket">
            {renderLabel(defaultValue)}
            <div className="form-addTicket-input" ref={divRef}>
                <div className="lstName-file">
                    <ul>{renderFiledUpload()}</ul>
                    <ul>{!props.isDuplicate && renderFileUploaded(defaultValue)}</ul>
                </div>

                {isDisplayBoxUploadFile() && (
                    <div
                        className="formUpload"
                        {...getRootProps()}
                        {...(isDisable ? preventDraggingOpenNewTab : {})}
                        data-cy="drop-file-input-upload"
                    >
                        <input disabled={isDisable} {...getInputProps()} />
                        <label htmlFor="contained-button-file">
                            <Button disabled={isDisable} variant="contained" component="span">
                                <div className="formUpload-item">
                                    <img src="/assets/image/icon-upload.svg" alt="" />
                                    <span
                                        className={`${
                                            isDisable ? 'fields-disabled' : ''
                                        } formUpload-txt`}
                                    >
                                        {trI18n('MSG-DRAG-DROP-FILE')}
                                    </span>
                                </div>
                            </Button>
                        </label>
                    </div>
                )}
                {props?.errorlist && props.errorlist[props.name]?.message && (
                    <div className="upload-file-error 1111">
                        {props.errorlist[props.name]?.message}
                    </div>
                )}

                {props.attachmentError && !Utils.isEmptyString(props.attachmentError) && (
                    <div className="upload-file-error pt-3">{tr(props.attachmentError)}</div>
                )}

                {isEmptyUploadFile() && (
                    <div className="upload-file-error pt-3">{tr('入力形式に誤りがあります')}</div>
                )}
            </div>

            <Popover
                open={Boolean(openOption) || false}
                anchorEl={openOption}
                onClose={() => {
                    setOpenOption(null);
                    setIsShowFlagMessage(false);
                }}
                TransitionProps={{
                    onExited: () => {
                        setOpenFileOption(null);
                    }
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {openFileOption?.shortKey && !Utils.isEmptyObject(props.detailTicket?.dataShareLink) && (
                        <FlagMessageCopyLink
                            title={trI18n('KNOWDEMSG002')}
                            placement="top-start"
                            arrow={true}
                            open={isShowFlagMessage}
                        >
                            <ButtonOption onClick={onClickCopyShareLink}>
                                <span
                                    style={{
                                        fontSize: 15,
                                        fontWeight: 400,
                                        fontFamily: 'Zen Kaku Gothic New'
                                    }}
                                >
                                    {trI18n('GET_URL')}
                                </span>
                            </ButtonOption>
                        </FlagMessageCopyLink>
                    )}
                    
                    {/* Replace file */}
                    {isCanReplaceFile() && (
                        <ButtonOption
                            onClick={handleOpenReplaceDialog}
                            disabled={isReplaceFileDisabled()}
                        >
                            <span
                                style={{
                                    fontSize: 15,
                                    fontWeight: 400,
                                    fontFamily: 'Zen Kaku Gothic New'
                                }}
                            >
                                {trI18n('LABEL-REPLACE-FILE-MENU')}
                            </span>
                        </ButtonOption>
                    )}

                    {/* File translation */}
                    {openFileOption?.canTranslateFile && (
                        <ButtonOption onClick={handleOpenTranslateDialog}>
                            <span
                                style={{
                                    fontSize: 15,
                                    fontWeight: 400,
                                    fontFamily: 'Zen Kaku Gothic New'
                                }}
                            >
                                {trI18n('LABEL-TRANSLATE-FILE-MENU')}
                            </span>
                        </ButtonOption>
                    )}

                    {openFileOption?.canOpenFileKnowledge && (
                        <ButtonOption onClick={handleOpenFileKnowledge}>
                            <span
                                style={{
                                    fontSize: 15,
                                    fontWeight: 400,
                                    fontFamily: 'Zen Kaku Gothic New'
                                }}
                            >
                                {trI18n('LABEL_OPEN_FILE_KNOWLEDGE')}
                            </span>
                        </ButtonOption>
                    )}
                    {openFileOption?.canEditPdfSearchTarget && (
                        <ButtonOption
                            disabled={
                                isDisable ||
                                openFileOption?.defaultSplitPdf
                            }
                            onClick={handleTogglePdfSearchTarget}
                        >
                            <span
                                style={{
                                    fontSize: 15,
                                    fontWeight: 400,
                                    fontFamily: 'Zen Kaku Gothic New'
                                }}
                            >
                                {openFileOption?.defaultSplitPdf ? trI18n('LABEL_SEARCH_PDF_INCLUDED') : (openFileOption?.splitPdf ? trI18n('LABEL_SEARCH_PDF_EXCLUDE') : trI18n('LABEL_SEARCH_PDF_INCLUDE'))}
                            </span>
                        </ButtonOption>
                    )}
                    {/* CR-2026-006: per-file auto-translate toggle (自動翻訳対象) */}
                    {openFileOption?.canEditAutoTranslate && (
                        <ButtonOption
                            disabled={
                                isDisable ||
                                isFileAlreadyAutoTranslated(openFileOption)
                            }
                            onClick={handleToggleAutoTranslateTarget}
                        >
                            <span
                                style={{
                                    fontSize: 15,
                                    fontWeight: 400,
                                    fontFamily: 'Zen Kaku Gothic New',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%'
                                }}
                            >
                                {trI18n('LABEL-ATTACHMENT-AUTO-TRANSLATE-TARGET')}
                                <div
                                    className="switch-check"
                                    onClick={e => e.stopPropagation()}
                                    style={{ marginLeft: 8 }}
                                >
                                    <input
                                        id="file_option_auto_translate"
                                        type="checkbox"
                                        checked={Boolean(openFileOption?.autoTranslate)}
                                        disabled={
                                            isDisable ||
                                            isFileAlreadyAutoTranslated(openFileOption)
                                        }
                                        onChange={handleToggleAutoTranslateTarget}
                                    />
                                    <label htmlFor="file_option_auto_translate"></label>
                                </div>
                            </span>
                        </ButtonOption>
                    )}
                    {!Utils.isEmptyObject(openFileOption) &&
                        !openFileOption?.originId?.includes('post') && (
                            <ButtonOption
                                disabled={isDisable || isReplaceFileDisabled()}
                                onClick={() => {
                                    if (!openFileOption?.isNewImg) {
                                        deleteFile(
                                            openFileOption?.index + (openFileOption?.imageLength || 0)
                                        );
                                    } else {
                                        handleDeleteFile(openFileOption?.index);
                                    }
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: 15,
                                        fontWeight: 400,
                                        fontFamily: 'Zen Kaku Gothic New'
                                    }}
                                >
                                    {trI18n('DELETE')}
                                </span>
                            </ButtonOption>
                        )}
                </div>
            </Popover>

            <Dialog
                open={!!openPreviewImage}
                onClose={() => setOpenPreviewImage(null)}
                maxWidth="md"
            >
                <img
                    alt=""
                    src={openPreviewImage}
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                    }}
                />
            </Dialog>

            <ReplaceFileDialog
                isOpen={isReplaceDialogOpen}
                onClose={() => setIsReplaceDialogOpen(false)}
                originalFileName={
                    replaceTargetFile?.sourceFile?.fileName
                    || replaceTargetFile?.fileInfo?.fileName
                    || ''
                }
                originalFileUrl={
                    replaceTargetFile?.sourceFile?.fileUrl
                    || replaceTargetFile?.fileInfo?.fileUrl
                    || ''
                }
                onReplace={handleReplaceFile}
                detailTicket={props.detailTicket}
                limitFileSize={limitFileSize}
            />

            <FileTranslationDialog
                isOpen={isTranslateDialogOpen}
                onClose={() => setIsTranslateDialogOpen(false)}
                file={translateTargetFile}
                detailTicket={props.detailTicket}
            />
        </div>
    );
};

EditFileUploaded.propTypes = {
    fileUploadList: PropTypes.any,
    setFileUploadList: PropTypes.any,
    fileUpdatedList: PropTypes.any,
    setValue: PropTypes.any,
    register: PropTypes.any,
    listFieldEdited: PropTypes.any,
    componentName: PropTypes.any,
    addTicket: PropTypes.any,
    setFileUpdatedList: PropTypes.any,
    name: PropTypes.any,
    detailTicket: PropTypes.any,
    setIsShowPopupLogout: PropTypes.any,
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    panelInitData: PropTypes.any,
    setPanelInitData: PropTypes.any,
    hasEditFieldPermissions: PropTypes.any,
    selectTicketType: PropTypes.any,
    ticketType: PropTypes.any,
    setShowButtonEditTicket: PropTypes.any,
    data: PropTypes.any,
    defaultValue: PropTypes.any,
    isTriggerReloadCurrentTicket: PropTypes.any,
    fileDeletedList: PropTypes.any,
    isEmail: PropTypes.any,
    isDisableEdit: PropTypes.any,
    attachmentError: PropTypes.any,
    allowMultipleFiles: PropTypes.bool,
    acceptedFileExtensions: PropTypes.array,
    limitFileSize: PropTypes.number,
    setIsEdited: PropTypes.func,
    setOnChangeEdit: PropTypes.func,
    onChangeEdit: PropTypes.bool,
    setListFieldEdited: PropTypes.func,
    clearErrors: PropTypes.func,
    setErrorCreateTicket: PropTypes.func,
    currentPanelInitData: PropTypes.object,
    parentForm: PropTypes.object,
    note: PropTypes.string,
    isShowIconCopyFieldId: PropTypes.bool,
    displayMode: PropTypes.string
};
